import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import CustomDateTimePicker from '@shared/component/DatePicker';
import TextInput from '@shared/component/TextInput';
import MultiSelect from '@shared/component/MultiSelect';

// Create the CommonModal component
const CommonModal = (props: any) => {
    // State to manage the modal visibility
    const [show, setShow] = useState(props.showModel || true);
    const [multiSelectComponents, setMultiSelectComponents] = useState<{ key: number }[]>([{ key: 0 }]);

    const handleModel = flag => {
        setShow(flag);
        props.demanModelCallback(false);
    };

    const check = val => {
        const a =
            val?.sampleId != null
                ? val?.sampleId.split('.')[1] == 'jpeg' ||
                  val?.sampleId.split('.')[1] == 'jpg' ||
                  val?.sampleId.split('.')[1] == 'png'
                    ? process.env.REACT_APP_API_BASE + val.sampleId
                    : 'pdf'
                : null;

        return a;
    };

    const addMultiSelect = () => {
        try {
            setMultiSelectComponents(prevComponents => [
                ...prevComponents,
                { key: prevComponents.length, index: prevComponents.length },
            ]);
        } catch (error) {}
    };

    const renderMultiSelect = (key, index) => (
        <>
            <div className="row" key={key}>
                <div className="col-sm-6">
                    <MultiSelect
                        isSingle={true}
                        // options={locationData}
                        placeholder={'In Between Stop'}
                        // getMultiSelectValue={e => getValueMidLocation(e, index)}
                        displayName="fullcity"
                        displayValue="id"
                        isClearable={false}
                        isDisabled={true}
                        setSelectedValues={
                            props?.data?.demand?.midLocationIdArray?.[index]
                                ? props?.data?.demand?.midLocationIdArray?.[index]
                                : null
                        }
                    />
                </div>
                <div></div>
            </div>
        </>
    );

    useEffect(() => {
        for (let i = 1; i < props?.data?.demand?.midLocationIdArray?.length; i++) {
            addMultiSelect();
        }
    }, [props?.data?.demand?.midLocationIdArray]);

    return (
        <>
            {/* The Modal component */}
            <Modal
                scrollable={true}
                show={show}
                onHide={() => {
                    handleModel(false);
                }}
                backdrop="static"
                keyboard={false}
                size={'lg'}
            >
                <Modal.Header closeButton>
                    <Modal.Title> Demand Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="material_form_cover">
                        <form
                            onSubmit={e => {
                                e.preventDefault();
                            }}
                        >
                            <div className="field_box">
                                <h3>BidType</h3>
                                <div className="check_field_box mb-4">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault1"
                                            value={'auto'}
                                            checked={props?.data?.demand?.bidType === 'auto'}
                                            disabled={true}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault1">
                                            Auto
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault2"
                                            value={'manual'}
                                            checked={props?.data?.demand?.bidType === 'manual'}
                                            disabled={true}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault2">
                                            Manual
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <br></br>

                            <div className="field_box">
                                <h3>Pick Up & Delivery Details</h3>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'number',
                                                    placeholder: 'Select Pickup*',
                                                    name: 'weight',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="weight"
                                                // isSubmit={isSubmit}
                                                value={`${props?.data?.demand?.from?.city}(${props?.data?.demand?.from?.pincode})`}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    weight: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <CustomDateTimePicker
                                                data={{
                                                    name: 'cutOffTime',
                                                    placeholder: 'Select Cut Off Date and Time',
                                                    label: 'Cut Off Date',
                                                    type: 'datetime-local',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="cutOffTime"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.cutOffTime}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                    {props?.data?.demand?.midLocationIdArray?.length > 0 &&
                                        multiSelectComponents.map(({ key }, index) =>
                                            //console.log('000000000'),
                                            renderMultiSelect(key, index),
                                        )}

                                    {/* <div className="col-sm-6"></div> */}

                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'number',
                                                    placeholder: 'Select Drop*',
                                                    name: 'weight',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="weight"
                                                // isSubmit={isSubmit}
                                                value={`${props?.data?.demand?.to?.city}(${props?.data?.demand?.to?.pincode})`}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    weight: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <CustomDateTimePicker
                                                data={{
                                                    name: 'pickUpDate',
                                                    placeholder: 'Select Pickup Date and Time',
                                                    id: 'floatingInput',
                                                    label: 'Pickup Date',
                                                }}
                                                controlName="pickUpDate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.pickUpDate}
                                                // setValue={(e: any) => getValue(e)}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'number',
                                                        placeholder: 'Select Transporter*',
                                                        name: 'weight',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="weight"
                                                    // isSubmit={isSubmit}
                                                    value={props?.data?.app_user?.name}
                                                    setValue={e => {
                                                        // console.log('e', e);
                                                    }}
                                                    inputProps={{
                                                        weight: {
                                                            disabled: true,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <CustomDateTimePicker
                                                data={{
                                                    name: 'deliveryDate',
                                                    placeholder: 'Select Delivery  Date and Time',
                                                    label: 'Delivery  Date',
                                                    type: 'datetime-local',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="deliveryDate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.deliveryDate}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="field_box">
                                <h3>Additional Details</h3>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'number',
                                                    placeholder: 'Select Material',
                                                    name: 'weight',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="weight"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.materialType}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    weight: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'number',
                                                    placeholder: 'Weight',
                                                    name: 'weight',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="weight"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.weight}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    weight: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {
                                        // (itemtype) &&
                                        <div className="col-sm-3">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'number',
                                                        placeholder: 'Select Unit',
                                                        name: 'weight',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="weight"
                                                    // isSubmit={isSubmit}
                                                    value={props?.data?.demand?.itemUnit}
                                                    setValue={e => {
                                                        // console.log('e', e);
                                                    }}
                                                    inputProps={{
                                                        weight: {
                                                            disabled: true,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    }

                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'number',
                                                    placeholder: 'No. of Vehicle Required',
                                                    name: 'noOfVehicles',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="noOfVehicles"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.noOfVehicles}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    noOfVehicles: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'number',
                                                    placeholder: 'Min Bid Rate (In Rs.)',
                                                    name: 'minBidRate',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="minBidRate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.minBidRate}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    minBidRate: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-3">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'number',
                                                    placeholder: 'Max Bid Rate (In Rs.)',
                                                    name: 'maxBidRate',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="maxBidRate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.maxBidRate}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    maxBidRate: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {props?.data?.demand?.description && props?.data?.demand?.description != '' ? (
                                        <div className="col-sm-12">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Description',
                                                        name: 'description',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="description"
                                                    // isSubmit={isSubmit}
                                                    value={props?.data?.demand?.description}
                                                    setValue={e => {
                                                        // console.log('e', e);
                                                    }}
                                                    inputProps={{
                                                        description: {
                                                            disabled: true,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                    <div className="col-sm-12">
                                        <>
                                            {' '}
                                            {check(props?.data?.demand) != null ? (
                                                <>
                                                    <div className="field_box">
                                                        <h3>Attachment</h3>
                                                    </div>

                                                    {check(props?.data?.demand) == 'pdf' ? (
                                                        <>
                                                            <div className="previewpdf">
                                                                <a
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    href={`${process.env.REACT_APP_API_BASE}${props?.data?.demand?.sampleId}`}
                                                                >
                                                                    <img
                                                                        src="./assets/images/pdficon.svg"
                                                                        className="img-fluid"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <span className="sm_info_text_box">Click To View</span>
                                                        </>
                                                    ) : (
                                                        <div className="previewimage">
                                                            <img
                                                                src={check(props?.data?.demand)}
                                                                className="img-fluid w-100 h-100"
                                                            />
                                                        </div>
                                                    )}
                                                    <br />
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CommonModal;
